import { GRAPH_ROUTES } from '../../constants/_routes'
import graphsTypes from '../../constants/graphsTypes'
import { axios } from '../../services'

const reset_graphs = () => {
  return {
    type: graphsTypes.reset
  }
}

const clear_graph_dates = () => {
  return {
    type: graphsTypes.clear_dates
  }
}


// INDEX
const get_graphs_request = () => {
  return {
    type: graphsTypes.get.request
  }
}

const get_graphs_success = (response) => {
  return {
    type: graphsTypes.get.success,
    payload: response.data
  }
}

const get_graphs_failure = (messages) => {
  return {
    type: graphsTypes.get.failure,
    payload: messages
  }
}

const get_graphs = (graph_types=[], from=null, to=null, skill=null) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_graphs_request())

    // Request
    axios.get(
      GRAPH_ROUTES.get,
      {
        params: {
          from: from,
          to: to,
          graphs: graph_types,
          skill: skill
        }
      }
    ).then( response => {
      // success
      dispatch( get_graphs_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching graphs."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_graphs_failure(errors))
    })
  }

}

export {
  reset_graphs,
  clear_graph_dates,
  get_graphs
}



// WEBPACK FOOTER //
// ./src/js/actions/graphs/index.js